import { useEffect, useState } from "react";

// Prevents overlay pile-up: the chat bubble and accessibility widget stay hidden
// while the cookie banner is on screen, so it can never cover price or CTA.
export const COOKIE_KEY = "loftloom_cookie_consent";
const EVENT = "loftloom:cookie-banner";

let bannerVisible = false;

export function setCookieBannerVisible(visible: boolean) {
  bannerVisible = visible;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: visible }));
}

export function isCookieBannerVisible() {
  return bannerVisible;
}

/** True while the cookie banner occupies the bottom of the screen. */
export function useCookieBannerVisible(): boolean {
  const [visible, setVisible] = useState(() => bannerVisible);

  useEffect(() => {
    const handler = (e: Event) => setVisible(Boolean((e as CustomEvent).detail));
    window.addEventListener(EVENT, handler);
    setVisible(bannerVisible);
    return () => window.removeEventListener(EVENT, handler);
  }, []);

  return visible;
}
